import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel, QueryCellInfoEventArgs, SearchSettingsModel, TextWrapSettingsModel, ToolbarItems ,FilterSettingsModel, IFilter } from '@syncfusion/ej2-angular-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/environment.service';
import { GlobalComponent } from 'src/app/global/global.component';
import {columnWidth } from '../employee/employee.model';
import { OperationalDashboardService } from '../operational-dashboard/operational-dashboard.service';
import { ColumnChangeBO, functionpermission, GetListBO, ImportreturnBO, returnimport835, WhereCondition } from './import-payment.model';
import { ImportService } from './import-payment.service';
import * as pbi from "powerbi-client";
import { GetHTTPImportService } from './import-paymentlist.service';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { searchfilterDetails } from './import-payment.model';
import { ImportBO } from './import-payment.model';
import { CommonApiService } from 'src/app/commonapiservice';

declare var $: any;

@Component({
  selector: 'app-import-payment',
  templateUrl: './import-payment.component.html',
  styleUrls: ['./import-payment.component.scss']
})
export class ImportPaymentComponent implements OnInit {private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('pdflist') pdflist;
  fileToUpload: any = "";
  selectedFileName: any = "";
  public wrapSettings: TextWrapSettingsModel;
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  TotalUnits: any = 0;
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  Filter_drop: searchfilterDetails;
  Report83: any;
  pageitems: number = 20;
  p: number = 1;
  TotalCount: number;
  Importarray: ImportreturnBO[];
  getErr: any = "";
  downloadarray: any = [];
  ImportDataList: any = [];
  Report835: any;
  onDOCFileChangedErr: any = ""
  Importreturn: ImportreturnBO = new ImportreturnBO()
  filepath: string;
  viewFiles: boolean = false
  Import: ImportBO = new ImportBO();
  serviceLineDetail: any;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  clientview: boolean = false;
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  public filterSettings: object;
  ListSendBO: GetListBO = new GetListBO();
  companydetails: any;
  payorDetail: any;
  paymentDetail: any;
  patientClaimDetails: any;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  type: string = "";
  ColumnArray: columnWidth[];
  public formatOptions: object;
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  constructor(public CommonAPI: CommonApiService, public http: HttpClient, public global: GlobalComponent, public toastrService: ToastrService,) {
    this.global.agencyList();
    this.data = CommonAPI;
  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.wrapSettings = { wrapMode: 'Content' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: 10, pageSizes: this.pageSizes };
    this.ListSendBO.currentpageno = 1;
    this.ListSendBO.pageitem = 10;
    this.getImportFilter();
    
  }
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      if (this.ListSendBO.type == "date") {

        this.ListSendBO.value = this.global.getDateTimeString(state.action?.currentFilterObject?.value);
        this.ListSendBO.field = state.action?.currentFilterObject?.field;
      }
    else if (this.ListSendBO.type == "number") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.operator = 'equal'
      this.ListSendBO.value = (state.action.currentFilterObject.value!=null&&state.action.currentFilterObject.value!=undefined&&state.action.currentFilterObject.value!='')?state.action.currentFilterObject.value.toString():'0';
      }
      else {
      this.ListSendBO.value = state.action.currentFilterObject.value?.toString();
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.type = state.action.currentFilterObject.type;

      }
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "fileName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
        this.ListSendBO.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Import.Pagesize != state.take) {
          this.arraycol[0].Import.Pagesize = state.take
          // this.SaveColumnwidth();
        }
      }
    }
    if (this.type != "stringfilterrequest") {
      this.getImportFilter();
    }
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Import.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });

          });

          this.arraycol[0].Import.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });

          });


          if (this.arraycol[0].Import.ShowColumns.length != count1 || this.arraycol[0].Import.HideColumns.length != count) {
            this.arraycol[0].Import.ShowColumns = showarr;
            this.arraycol[0].Import.HideColumns = hidearr;
            // this.SaveColumnwidth();
          }
        }

      }
    }
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListSendBO.type = args.columnType
    }

  }
  onFileChanged(file) {
    this.fileToUpload = file.item(0);
    this.selectedFileName = file.item(0).name;
  }
  onDOCFileChanged() {
    this.Importreturn.fileName = this.fileToUpload.name
    this.selectedFileName = this.fileToUpload.name;
    let body = new FormData();
    body.append('Filepath', this.fileToUpload);

    let url = "api/Import/SaveImport";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(body,url).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: returnimport835) => {
        this.Report835 = data.invoice;
        if (data.invoice != null) {
          this.viewFiles = true
        }
        this.getImportFilter()
        if (data.error != null && data.error != undefined && data.error != "") {
          this.onDOCFileChangedErr = data.error;
          setTimeout(function () {
            this.onDOCFileChangedErr = "";
          }.bind(this), 8000);
        }
        this.toastrService.success(
          "File will be imported shortly",
          "File imported",
        ), 8000


      },
      (err: any) => {

        this.onDOCFileChangedErr = "";
        this.onDOCFileChangedErr = err;
        if (this.onDOCFileChangedErr != "") {
          setTimeout(function () {
            this.onDOCFileChangedErr = "";
          }.bind(this), 8000);

        }
      }
    );
  }
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.margin = { left: "0.6cm", top: "0.4cm", right: "0.6cm", bottom: "3cm" }
    this.pdflist.saveAs("837Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }
  paginationChange(event) {
    this.p = event;
    this.getImportarray();

  }
  pageItemsChage(pageitems) {
    this.pageitems = pageitems;
    this.getImportarray();
    this.getTotalCount();

  }
  Refresh() {
    this.fileToUpload = '';
    this.selectedFileName = '';
    this.ListSendBO.field = 'fileName';
    this.ListSendBO.value = '';
    this.ListSendBO.currentpageno = 1;
    this.getImportFilter();
    this.getTotalCount();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  getImportarray() {
    console.log('getimportarray')
    let params = new URLSearchParams();
    params.append("Pageitem", this.pageitems.toString());
    params.append("Currentpageno", this.p.toString());
    let url = "api/Import/GetImport?";
    this.http.get(url+params).pipe(takeUntil(this.onDestroy$)).subscribe((data: ImportreturnBO[]) => {
      this.Importarray = data;
    }, (err: HttpErrorResponse) => {
      if (err.error.errors) {
        this.getErr = JSON.stringify(err.error.errors);
      }
      else {
        this.getErr = JSON.stringify(err.error);
      }
      if (this.getErr != "") {
        setTimeout(() => {
          this.getErr = "";
        }, 8000)
      }

    })
  }
  getTotalCount() {
    let params = new URLSearchParams();
    let url = "api/Import/GetImportDataCount?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.TotalCount = data;
    }, (err: HttpErrorResponse) => {
      if (err.error.errors) {
        this.getErr = JSON.stringify(err.error.errors);
      }
      else {
        this.getErr = JSON.stringify(err.error);
      }
      if (this.getErr != "") {
        setTimeout(() => {
          this.getErr = "";
        }, 8000)
      }
    })
  }
 
  viewFile(data) {
    this.TotalUnits = 0;
    let params = new URLSearchParams();
    let url = "api/Import/GetInvoice835?";
    params.append("Claim_835Id", data.id);
    this.http.get(url+params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Report835 = data;
      // $('#viewmodal').modal({
      //   show: true,
      //   zIndex: 1000000
      // })
      document.getElementById('openModal1').click();
      this.viewFiles = true
      this.Report835[0].transaction835s.forEach(element => {
        this.companydetails = element.companydetails
        this.payorDetail = element.payorDetail
        this.paymentDetail = element.paymentDetail
        this.patientClaimDetails = element.patient_ClaimDetails
        element.patient_ClaimDetails.forEach(element1 => {
          this.TotalUnits = this.TotalUnits + element1.totalUnit;
        });
      });
    },  (err: HttpErrorResponse) => {

      if (err.error != null) {
        this.onDOCFileChangedErr = err.error;
      }
      if (err.error.errors) {
        this.onDOCFileChangedErr = JSON.stringify(err.error.errors);
      }
      else {
        this.onDOCFileChangedErr = JSON.stringify(err.error);
      }
    })
  }
  downloadImportFile(file) {
    if (file != null) {
      window.open(file);
    }
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  getImportFilter() {
    let url = "api/Import/GetImportFilters?"
    let responseData =
    {
      result: "iList",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.ListSendBO, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ImportDataList = data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
      }
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result.length > 15) {
          this.grid.height = '500';
        }
        else {
          this.grid.height = 'auto';
        }
      }
    })
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }

      });
      // this.SaveColumnwidth();
    }
  }
 
 
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

